import {MutationTree} from "vuex";
import {EventProfileState, EventProfile} from "./model";

const mutations: MutationTree<EventProfileState> = {
  setEventProfiles(state, eventProfiles: EventProfile[]) {
    state.eventProfiles = eventProfiles;
  },
  addEventProfile(state, eventProfile: EventProfile) {
    state.eventProfiles.push(eventProfile);
  },
  updateEventProfile(state, eventProfile: EventProfile) {
    const c = state.eventProfiles.find(c => c.id === eventProfile.id);
    Object.assign(c, eventProfile);
  },
  deleteEventProfile(state, id: string) {
    state.eventProfiles = state.eventProfiles.filter(eventProfile => eventProfile.id !== id);
  }
}

export default mutations;
